import { render, staticRenderFns } from "./AddTriggerMail.vue?vue&type=template&id=8840688e&scoped=true&"
import script from "./AddTriggerMail.vue?vue&type=script&lang=js&"
export * from "./AddTriggerMail.vue?vue&type=script&lang=js&"
import style0 from "./AddTriggerMail.vue?vue&type=style&index=0&id=8840688e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8840688e",
  null
  
)

export default component.exports